export const IDLE_TIME_OUT_TIME = 60 * 1000 * 25
